import Vue from 'vue'
import Router from 'vue-router'
import routes from "./routes"
import UserService from "./../service/UserService"
Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes
 
})

router.beforeEach( (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth )) {//precisa de autorização?
    let user = UserService.getLoggedUser();
    if (user == null) {//usuario é nulo?
      next({path: '/'});
    }
    else if(to.matched.some(record => record.meta.access )){//requer permissão de acesso?
      let entities = UserService.getEntites();
      if (to.matched.some(record => !entities.includes(record.meta.access))) {//usuario NÃO tem permissão?
        next({path:'/unauthorized'}) 
      }
      else next();
    }
    else next()
  }
  else next();
    
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js